import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function FloatingCart() {
  const { count } = useCart();

  return (
    <Link
      to="/cos"
      aria-label="Coșul meu"
      data-testid="floating-cart"
      className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-sky-600 text-white shadow-lg shadow-sky-600/40 transition-transform hover:scale-105 hover:bg-sky-500 sm:bottom-8 sm:right-8"
    >
      <ShoppingCart className="h-6 w-6" />
      {count > 0 && (
        <span
          className="absolute -right-1 -top-1 grid h-6 w-6 place-items-center rounded-full bg-emerald-500 text-xs font-bold text-white ring-2 ring-white"
          data-testid="floating-cart-count"
        >
          {count}
        </span>
      )}
    </Link>
  );
}
